var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"editor-container"},[_c('tui-editor',{ref:"toastuiEditor",attrs:{"height":"450px","options":_vm.options,"initialValue":_vm.text,"initialEditType":"wysiwyg"},on:{"load":_vm.onEditorLoad,"focus":_vm.onEditorFocus,"blur":_vm.onEditorBlur,"change":_vm.onEditorChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }